<template>
  <div>
    <GameTable />
  </div>
</template>

<script>
import store from "../store";
import GameTable from "./GameTable.vue";
export default {
  name: "Game",
  store,
  components: {
    GameTable
  },
  computed: {
    gameCards() {
      return this.$store.getters.gameCards;
    },
    created() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Game.vue